import { useEffect, useRef, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { hasAuthParams, useAuth } from "react-oidc-context";
import { Outlet } from "react-router-dom";
import { IdleSessionModal } from "./IdleSessionModal";
import { LoginErrorScreen } from "./LoginErrorScreen";
import Spinner from "../../../components/ui/spinners/CompactLoadingSpinner";


export const ProtectedRoute = () => {

  const auth = useAuth();

  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  const [isIdleModalOpen, setIsIdleModalOpen] = useState(false);
  const logoutTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if(!(hasAuthParams() || auth.isAuthenticated || auth.activeNavigator || auth.isLoading || hasTriedSignin)) {
      void auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin])

  const handleOnIdle = (): void => {
    if (auth.isAuthenticated) {
      setIsIdleModalOpen(true);
      // Start a countdown for automatic logout after 30 seconds if user doesn't respond
      logoutTimeoutRef.current = setTimeout(() => {
        auth.signoutRedirect();
      }, 30000);
    }
  };


  useIdleTimer({
    timeout: 1000 * 60 * 15, // 15 minutes
    crossTab: true,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  const handleStayActive = (): void => {
    setIsIdleModalOpen(false);
    if (logoutTimeoutRef.current) {
      clearTimeout(logoutTimeoutRef.current);
    }
  };

  const handleLogout = (): void => {
    setIsIdleModalOpen(false);
    if (logoutTimeoutRef.current) {
      clearTimeout(logoutTimeoutRef.current);
    }
    auth.signoutRedirect();
  };

  const handleLogin = (): void => {
    auth.signinRedirect();
  };
  
  switch (auth.activeNavigator) {
    // Todo: A proper sign in / sign out loading page 
    case "signinSilent":
      return <Spinner isFixed message='Signing you in...' showDefaultSubtitle={false} />;
    case "signoutRedirect":
      return <Spinner isFixed message='Signing you out...' showDefaultSubtitle={false} />;
  }

  if (auth.isLoading) {
    return <Spinner isFixed message='Loading...' showDefaultSubtitle={false} />;
  }

  if (auth.error?.message) {
    return <LoginErrorScreen onLogin={handleLogin} />;
  }

  if (!auth.isAuthenticated) {
    return <LoginErrorScreen onLogin={handleLogin} />;
  }

  return (
    <>
      <IdleSessionModal isOpen={isIdleModalOpen} onLogout={handleLogout} onStayActive={handleStayActive}/>
      <Outlet />
    </>
  )
}